import React, {useEffect, useState} from 'react'
import { translations } from "./translations";
import {Routes, Route} from 'react-router-dom'
import 'bootstrap/dist/css/bootstrap.min.css'
import ProtectedAdminRoute from './components/ProtectedAdminRoute';

//Pages
import Home from './pages/Home'
import Projects from './pages/Projects'
import Project from './pages/Project'
import Medias from './pages/Medias'
import Portfolio from './pages/Portfolio'
import Performances from './pages/Performances'
import Contact from './pages/Contact'
import About from './pages/About'
import Agenda from './pages/Agenda'
import LegalNotices from './pages/LegalNotices'
import PrivacyPolicy from './pages/PrivacyPolicy'
//Admin
import Admin from './pages/Admin'
import LoginAdmin from './pages/LoginAdmin';

//Components
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import ScrollToTop from "./components/ScrollToTop";

export default function App() {

  // 🔥 Auto detect browser language
  const browserLang = navigator.language.startsWith("fr") ? "fr" : "en";

  const [lang, setLang] = useState(
  localStorage.getItem("lang") || browserLang
  );

  useEffect(() => {
    localStorage.setItem("lang", lang);
  }, [lang]);

  const t = (key) => translations[lang][key] || key;

  const [isAdmin, setIsAdmin] = React.useState(null);

  useEffect(() => {
    fetch('/api/auth-check.php', {
      credentials: 'include'
    })
      .then(res => res.json())
      .then(data => setIsAdmin(data.authenticated))
      .catch(() => setIsAdmin(false));
  }, []);

  return (
    <>
      <div className="app-wrapper">
        <ScrollToTop />
        <Navbar t={t} lang={lang} setLang={setLang} />

        
        <Routes>
          <Route path="/" element={<Home t={t} lang={lang} />} />
          <Route path="/about" element={<About t={t} lang={lang} />} />
          <Route path="/agenda" element={<Agenda t={t} lang={lang} />} />
          <Route path="/projects" element={<Projects t={t} />} />
          <Route path="/projects/:id" element={<Project lang={lang} />} />
          <Route path="/medias" element={<Medias t={t} lang={lang} />} />
          <Route path="/medias/portfolio" element={<Portfolio t={t} />} />
          <Route path="/medias/performances" element={<Performances t={t} />} />
          <Route path="/contact" element={<Contact t={t} />} />

          <Route path="/legal-notices" element={<LegalNotices t={t} />} />
          <Route path="/privacy_policy" element={<PrivacyPolicy t={t} />} />

          <Route
            path="/admin"
            element={
              <ProtectedAdminRoute isAdmin={isAdmin}>
                <Admin setIsAdmin={setIsAdmin} />
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="/login-admin"
            element={
              <LoginAdmin
                isAdmin={isAdmin}
                setIsAdmin={setIsAdmin}
              />
            }
          />
        </Routes>
        <Footer t={t} lang={lang} />
      </div>
    </>
  );
}